import React from 'react'
import { getTrialBalance } from 'utils/api-routes-accounts'
import ReportTablePage from './ReportTablePage'
import { useFinanceObservable } from '../../hooks/useFinanceObservable'

const TrialBalance = () => {
  const report = useFinanceObservable<any[]>(() => getTrialBalance({}))

  return (
    <ReportTablePage
      title="Trial Balance"
      rows={report.data || []}
      isLoading={report.loading}
      columns={[
        {
          name: 'Code',
          selector: (row) => row.account_code || row.code || '--',
        },
        {
          name: 'Account',
          selector: (row) => row.account_name || row.name || '--',
        },
        {
          name: 'Debit',
          selector: (row) => row.debit || row.debit_balance || 0,
        },
        {
          name: 'Credit',
          selector: (row) => row.credit || row.credit_balance || 0,
        },
        { name: 'Balance', selector: (row) => row.balance || 0 },
      ]}
    />
  )
}

export default TrialBalance
